import { IS_PHONE_BROWSER, IS_PUBLIC_FOLDER, IS_WEBVIEW } from "reactApp/appHelpers/configHelpers";

export const isReactMobilePublic = IS_PUBLIC_FOLDER && (IS_WEBVIEW || IS_PHONE_BROWSER);
